// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import type { JsonValueType } from '../inputTypeSchemas/JsonValueSchema';
import { ExternalNetworkScanWithRelationsSchema } from './ExternalNetworkScanRelationsSchema'
import type { ExternalNetworkScanWithRelations } from './ExternalNetworkScanRelationsSchema'
import { ActivityRunSchema } from './ActivityRunSchema';

/////////////////////////////////////////
// ACTIVITY RUN RELATION SCHEMA
/////////////////////////////////////////

export type ActivityRunRelations = {
  scan?: ExternalNetworkScanWithRelations | null;
};

export type ActivityRunWithRelations = Omit<z.infer<typeof ActivityRunSchema>, "metadata"> & {
  metadata?: JsonValueType | null;
} & ActivityRunRelations

export const ActivityRunWithRelationsSchema: z.ZodType<ActivityRunWithRelations> = ActivityRunSchema.merge(z.object({
  scan: z.lazy(() => ExternalNetworkScanWithRelationsSchema).nullable(),
}))